import React, { FC, useCallback, useState } from 'react';

import { ReportingTable, type ReportingTableProps } from '~/components/ReportingTable';
import { statementTableColumns, useStatementAccounts } from '~/components/StatementTableColumns';
import { ReportingSettlementReport } from '~/typings/API';

type StatementsTableProps = Omit<ReportingTableProps, 'columns' | 'onEntriesChange' | 'isLoadingRows'> & {
  hideAccount?: boolean;
};

export const StatementsTable: FC<StatementsTableProps> = ({ hideAccount, ...props }) => {
  const [entries, setEntries] = useState<ReportingSettlementReport[]>([]);
  const { accountsById, isLoading } = useStatementAccounts(hideAccount ? [] : entries);
  const columns = useCallback<NonNullable<ReportingTableProps['columns']>>(
    (options) => statementTableColumns({ ...options, accountsById, hideAccount }),
    [accountsById, hideAccount]
  );

  return <ReportingTable {...props} columns={columns} onEntriesChange={setEntries} isLoadingRows={isLoading} />;
};
